import React, { useState, useEffect, useReducer } from 'react';
import {
  Button,
  Checkbox,
  Select,
  Space,
  Statistic, Tooltip
} from 'antd';
import {
  CloseOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { toThousands, toFixed2 } from '../../utils/Numeric';
import { SimpleTable } from '../../components';
import {
  getOrderPackageProgress
} from '../../services/Order';
const { Countdown } = Statistic;
export default React.forwardRef((props, ref) => {
  const { order, onCloseCallback, tabStatus,
    setTabStatus } = props;
  const [progress, setProcess] = useState([]);
  const [isShowNoCompleted, setShowNoCompleted] = useState(false);
  const [selectedGoodsId, setSelectedGoodsId] = useState(undefined);

  const progressInfo = { orderGoodsCount: 0, orderGoodsOkCount: 0 };
  progress.forEach((x, i) => {
    x.order_goods_count && (progressInfo.orderGoodsCount += x.order_goods_purchase_count);
    x.order_goods_delivery_ok_count && (progressInfo.orderGoodsOkCount += x.order_goods_delivery_ok_count);
  });
  useEffect(() => {
    reload();
  }, [])

  const reload = (callback) => {
    getOrderPackageProgress(order.id).then(data => {
      setProcess(data);
    });
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onChangeGoods = (id) => {
    setSelectedGoodsId(id);
  }

  const onChangeNoCompleted = (e) => {
    setShowNoCompleted(e.target.checked);
  }

  let targetRows = [].concat(progress);
  if (isShowNoCompleted) {
    targetRows = targetRows.filter(x => x.order_goods_count > x.order_goods_delivery_ok_count)
  }
  const goodsOptions = [{ id: -1, name: '--全部产品--' }];
  targetRows.forEach(x => {
    if (goodsOptions.find(y => y.id === x.goods_spec_id) === undefined) {
      goodsOptions.push({ id: x.goods_spec_id, name: x.goods_spec_name });
    }
  });
  if (selectedGoodsId > 0) {
    targetRows = targetRows.filter(x => x.goods_spec_id === selectedGoodsId)
  }

 
  const header = [
    {
      label: '产品号', width: '80px', render: (text, row, index) => {
        return <span>{row.goods_spec_name}</span>
      }
    },
    {
      label: '尺寸', align: 'center', width: '90px', render: (text, row, index) => {
        return <span>{row.size}</span>
      }
    },
    {
      label: '产品名称', width: '245px', item: 'goods_name_en'
    },
    {
      label: '订单数量', align: 'right', width: '60px', render: (text, row, index) => {
        return <span>{row.order_goods_count}</span>
      }
    },
    {
      label: '采购数量(含补箱)', align: 'right', width: '80px', render: (text, row, index) => {
        return <span>{row.order_goods_purchase_count}</span>
      }
    },
    {
      label: '已发货数量[含计划中]', align: 'right', width: '80px', item: 'order_goods_delivery_ok_count'
    },
    {
      label: '剩余数量', align: 'right', width: '50px', render: (text, row, index) => {
        const diff = row.order_goods_purchase_count - (row.order_goods_delivery_ok_count || 0);
        if (diff === 0) {
          return 0;
        } else if (diff > 0) {
          return <span style={{ color: 'red' }}>{diff}</span>
        } else {
          return <span style={{ color: 'green' }}>{diff}</span>
        }
      }
    },
    {
      label: '', align: 'center', width: '60px', render: (text, row, index) => {
        if (row.order_goods_delivery_ok_count === 0) {
          return undefined;
        }
        let arr = JSON.parse(row.delivery_ok_detail_count || "[]");
        const content = <div style={{ padding: '0 1rem' }}>
          <div style={{ color: 'red' }}><strong>外方发货明细</strong></div>
          {
            arr.map((x, i) => {
              for (let xx in x) {
                if (x[xx] > 0)
                  return <span>{xx} : {x[xx]}件<br /></span>
                else return undefined;
              }

            })
          }
        </div>
        return <Tooltip title={content}>
          <Button size="small" type="link">查看</Button>
        </Tooltip>
        //}
      }
    }
  ];

  return (
    <div style={{ padding: '0 0' }}  >
      <div style={{ fontSize: '1.25rem', backgroundColor: 'gold', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', margin: '0 0 1rem 0' }}>
        <div>
          <strong>当前外方交付进度({toFixed2(progressInfo.orderGoodsOkCount * 100.0 / progressInfo.orderGoodsCount, 1)}%)：[ {progressInfo.orderGoodsOkCount}/{progressInfo.orderGoodsCount}件 ]</strong>
          <Button onClick={reload} style={{ marginLeft: '2rem' }} icon={<ReloadOutlined />}>同步发货数据</Button>
        </div>
        <div>
          <Countdown value={order.delivery_deadline_date} format="剩余：D 天 H 时 m 分 s 秒" />
        </div>
      </div>
      <div style={{ padding: '0 1rem' }}>
        <Space style={{ padding: '1rem 0' }}>
          <Checkbox checked={isShowNoCompleted} onChange={onChangeNoCompleted}>只显示未完成</Checkbox>
          {
            goodsOptions.length > 1 && <Select 
              showSearch="true"
              optionFilterProp="children"
              style={{ width: '240px' }} 
              onChange={onChangeGoods} 
              defaultValue={-1}>
              {
                goodsOptions.map(x => {
                  return <Select.Option key={x.id} value={x.id}>{x.name}</Select.Option>
                })
              }
            </Select>
          }
          
        </Space>
        <SimpleTable isPaginition={false} header={header} rows={targetRows} />
        <div style={{ padding: '1rem 0', display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
        </div>
      </div>
    </div>
  );
});